import React, { Component, PropTypes } from 'react';
import Dashboard from 'components/Route/Dashboard';
import FullScreenDialog from 'components/FullScreenDialog';
import { mixin, RefluxMixin } from 'Util';
import { StoreOverviewActions } from 'actions';
import Constants from 'Constants';
import { translate as _l } from 'oxygen-i18n';
import { Colors, hexToRgba, brighten } from 'Css';

addTranslations({
  ['en-US']: {
    'Thank you!': 'Thank you!',
    '{0} is now available in your library.':
      '{0} is now available in your library.',
    'OK, start learning!': 'OK, start learning!',
    'Your course': 'Your course'
  },
  ['sv-SE']: {
    'Thank you!': 'Tack!',
    '{0} is now available in your library.':
      '{0} finns nu tillgänglig i ditt kursbibliotek.',
    'OK, start learning!': 'OK, sätt igång!',
    'Your course': 'Din kurs'
  }
});

const css = oxygenCss({
  root: {
    minHeight: 200,
    padding: 64
  },
  logo: {
    position: 'relative',
    width: 220,
    height: 72,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    margin: 'auto'
  },
  message: {
    textAlign: 'center'
  },
  header: {
    marginTop: 64,
    fontSize: 28,
    marginBottom: 24
  },
  button: {
    marginTop: 64,
    transition: 'all 0.25s ease',
    fontFamily: 'MaisonNeue-Demi',
    cursor: 'pointer',
    borderRadius: 3,
    backgroundColor: Colors.creen,
    minWidth: 64,
    textAlign: 'center',
    padding: `0px 4px`,
    color: '#ffffff',
    fontSize: 16,
    height: 40,
    lineHeight: '40px',
    letterSpacing: '0.6px',
    boxSizing: 'border-box',
    fontWeight: 500,
    ':hover': {
      boxShadow: `0 2px 0 0 ${brighten(Colors.creen, -0.2)}`,
      backgroundColor: `${hexToRgba(Colors.creen, 80)}`
    }
  }
});

class KlarnaConfirmation extends Component {
  static propTypes = {
    children: PropTypes.node,
    params: PropTypes.object
  };

  state = {
    confirmationOpen: true,
    klarnaDialog: true,
  };

  componentDidMount() {
    const { transactionId } = this.props;
    StoreOverviewActions.completePayment(
      null,
      Constants.paymentProviders.KLARNACHECKOUT,
      transactionId
    );
  }

  close = () => {
    this.props.router.push('/dashboard');
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.snippet !== nextProps.snippet) {
      const { snippet } = nextProps;
      const node = this.refs.klarnaDialog;
      node.innerHTML = snippet;
      const klarnaCode = node.getElementsByTagName('script')[0].text; //node.children[0].children[0].text;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      try {
        script.appendChild(document.createTextNode(klarnaCode));
      } catch (e) {
        script.text = klarnaCode;
      }
      node.appendChild(script);
    }
  }

  render() {
    const { confirmationOpen, klarnaDialog } = this.state;
    const { theme, cart } = this.props;
    const [item] = cart;
    return (
      <Dashboard>
        <FullScreenDialog
          maxi
          open={confirmationOpen}
          title={'Congratulations'}
        >
          <div className={css.root}>
            <div
              className={css.logo}
              style={{ backgroundImage: `url(${theme.logoUrl})` }}
            />
            <div className={css.message}>
              <div className={css.header}>{_l`Thank you!`}</div>
              <span>{_l`${(item && item.name) ||
                _l`Your course`} is now available in your library.`}</span>
            </div>
            <div
              className={css.button}
              onTouchTap={this.close}
            >{_l`OK, start learning!`}</div>
          </div>
        </FullScreenDialog>
        <FullScreenDialog
          maxi
          open={klarnaDialog}
          onRequestClose={() => this.setState({ klarnaDialog: false })}>
          <div ref="klarnaDialog" />
          <div
            className={css.button}
            onClick={() => this.setState({ klarnaDialog: false })}>
            Continue
          </div>
        </FullScreenDialog>
      </Dashboard>
    );
  }
}

export default KlarnaConfirmation;



// WEBPACK FOOTER //
// ./src/js/components/KlarnaConfirmation.js